import { createStyles, makeStyles } from '@material-ui/styles';
import palette from '../../../../theme/palette';

const style = () =>
  createStyles({
    root: {
      display: 'flex',
      gap: '10px',
      flexWrap: 'wrap'
    },
    categoryContainer: {
      display: 'flex',
      flexDirection: 'column',
      gap: '5px',
      width: '100%'
    },
    winnerContainer: {
      display: 'flex',
      gap: '10px',
      width: '100%'
    },
    name: {
      display: 'flex',
      flexWrap: 'wrap',
      gap: '5px 10px',
      alignItems: 'center',
      background: palette.background.underBox,
      color: palette.text.darker,
      fontSize: '1.2rem',
      borderRadius: palette.borderRadius.default,
      padding: '3px 10px',
      width: '100%'
    },
    lyceeName: {
      fontSize: '0.8rem'
    }
  });

const useStyle = makeStyles(style);
export default useStyle;
